<div class="dialog">


    <ng-container *ngIf="!existing" >
        <div class="dialog-header">
            <h3>{{ 'SALES_DOCUMENT|Kupujący - Edycja danych' | translate }}</h3>

            <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
                <icc-icon name="close"></icc-icon>
            </button>

        </div>

        <div class="dialog-body">
            <div class="w-100">
                <h1 class="w-100" >{{ 'SALES_DOCUMENT|Dane kontrahenta:' | translate }}</h1>
            </div>

            <form [formGroup]="contractorForm">

                <div class="form-box">

                    <div class="w-100 bb">

                        <span class="radio-group">

                            <icc-radio name="isCompany" id="is-person" name="is-company" [value]="false" formControlName="isCompany">
                                {{ 'PERSON|Osoba prywatna' | translate }}
                            </icc-radio>

                            <icc-radio name="isCompany" id="is-company" name="is-company"  [value]="true" formControlName="isCompany">
                                {{ 'COMPANY|Firma' | translate }}
                            </icc-radio>

                        </span>

                    </div>

                    <section class="w-100">

                        <div
                            *ngIf="contractorForm.get('isCompany')?.value"
                            class="w-100"
                        >
                            <label iccLabel >
                                {{ 'COMPANY|Nazwa Firmy' | translate }}
                            </label>
                            <icc-input type="text" formControlName="companyName" autocomplete="organization"></icc-input>

                            <label iccLabel>
                                {{ 'COMPANY|NIP' | translate }}
                            </label>
                            <icc-input type="text" formControlName="companyVatNr"></icc-input>

                            <label iccLabel >
                                {{ 'COMPANY|VAT-UE' | translate }}
                            </label>
                            <icc-input type="text" formControlName="companyVatNrEu"></icc-input>

                        </div>

                        <label iccLabel>
                            {{ 'PERSON|Imię' | translate }}
                        </label>

                        <icc-input type="text" name="first_name" formControlName="firstName" autocomplete="given-name"></icc-input>

                        <label iccLabel>
                            {{ 'PERSON|Nazwisko' | translate }}
                        </label>
                        <icc-input type="text" name="last_name" formControlName="lastName" autocomplete="family-name"></icc-input>

                        <label iccLabel>
                            {{ 'CONTACT|Email' | translate }}
                        </label>
                        <icc-input type="email" name="email"  formControlName="email" autocomplete="email"></icc-input>


                        <label iccLabel>
                            {{ 'CONTACT|Telefon' | translate }}
                        </label>
                        <icc-input type="text" formControlName="phoneNumber" autocomplete="work tel"></icc-input>

                    </section>

                    <section class="w-100">


                    </section>

                </div>

                <section class="w-100">
                    <p *ngIf="isRequiredInOrder()" class="warning" >*{{ 'SALES_DOCUMENT|Dane są wymagane do wysłania zamówienia' | translate }}</p>
                    <p *ngIf="!contractorForm.valid" class="error">{{ 'INTERFACE|Uzupełnij wymagane pola' | translate }}</p>
                </section>

                <div class="form-box">

                    <h4 class="w-100">{{ 'CONTACT|Adres dostawy:' | translate }}</h4>

                    <section formGroupName="delivery">

                        <div class="flex-horizontal w-100">
                            <div [ngClass]="{ 'w-100': !showRegions(contractorForm.get('delivery.countryId')?.value),'w-50': showRegions(contractorForm.get('delivery.countryId')?.value), 'pr-1': showRegions(contractorForm.get('delivery.countryId')?.value)}">

                                <label iccLabel>
                                    <span *ngIf="isRequiredInOrder()" >*</span>
                                    {{ 'CONTACT|Kraj' | translate }}
                                </label>
                                <icc-select formControlName="countryId" >
                                    <option
                                        *ngFor="let country of countries"
                                        [value]="country.id"
                                        autocomplete="shipping country"
                                    >
                                        {{ country.name }}
                                    </option>
                                </icc-select>

                            </div>
                            <div
                                *ngIf="showRegions(contractorForm.get('delivery.countryId')?.value)"
                                class="w-50 pl-1"
                            >

                                <label iccLabel>
                                    <span *ngIf="isRequiredInOrder()" >*</span>
                                    {{ getRegionLabel(contractorForm.get('delivery.countryId')?.value) }}
                                </label>
                                <icc-select formControlName="regionId" autocomplete="shipping address-level1">
                                    <option
                                        *ngFor="let region of getRegions(contractorForm.get('delivery.countryId')?.value)"
                                        [value]="region.id"
                                    >
                                        {{ region.name }}
                                    </option>
                                </icc-select>
                            </div>
                        </div>

                        <div class="flex-horizontal w-100">
                            <div class="fg-1" *ngIf="showSubregions(contractorForm.get('delivery.countryId')?.value)">
                                <label iccLabel>
                                    <span *ngIf="isRequiredInOrder()" >*</span>
                                    {{ getSubregionLabel(contractorForm.get('delivery.countryId')?.value) }}
                                </label>
                                <icc-select formControlName="subregionId"  autocomplete="shipping address-level2">
                                    <option
                                        *ngFor="let subregion of getSubregions(
                                            contractorForm.get('delivery.countryId')?.value,
                                            contractorForm.get('delivery.regionId')?.value
                                        )"
                                        [value]="subregion.id"
                                    >
                                        {{ subregion.name }}
                                    </option>
                                </icc-select>
                            </div>
                            <div class="fg-1">

                                <label iccLabel>
                                    <span *ngIf="isRequiredInOrder()" >*</span>
                                    {{ 'CONTACT|Kod pocztowy' | translate }}

                                </label>
                                <icc-input type="text" name="postal_code" formControlName="postalCode" autocomplete="shipping postal-code"></icc-input>

                            </div>

                            <div class="fg-1">

                                <label iccLabel>
                                    <span *ngIf="isRequiredInOrder()" >*</span>
                                    {{ 'CONTACT|Miejscowość' | translate }}
                                </label>
                                <icc-input type="text" name="city" formControlName="city" autocomplete="shipping address-level3" ></icc-input>

                            </div>
                        </div>

                        <div class="flex-vertical w-100">

                            <div class="w-100">
                                <label iccLabel>
                                    <span *ngIf="isRequiredInOrder()" >*</span>
                                    {{ 'CONTACT|Adres' | translate }}
                                </label>
                                <icc-input type="text" name="address_line_1" formControlName="addressLine1"  autocomplete="shipping address-line1"></icc-input>
                            </div>

                            <div class="w-100">
                                <label iccLabel>
                                    {{ 'CONTACT|Adres cd.' | translate }}
                                </label>
                                <icc-input type="text" name="address_line_2" formControlName="addressLine2" autocomplete="shipping address-line2" ></icc-input>
                            </div>

                        </div>


                    </section>

                </div>

                <div class="form-box">

                    <icc-checkbox name="invoiceFromDelivery" formControlName="invoiceFromDelivery">
                        {{ 'CONTACT|Użyj adresu dostawy na fakturze' | translate }}
                    </icc-checkbox>

                    <h4 class="w-100" >{{ 'CONTACT|Adres do faktury:' | translate }}</h4>

                    <section formGroupName="invoice">

                        <div class="flex-horizontal w-100">
                            <div [ngClass]="{ 'w-100': !showRegions(contractorForm.get('invoice.countryId')?.value),'w-50': showRegions(contractorForm.get('invoice.countryId')?.value), 'pr-1': showRegions(contractorForm.get('invoice.countryId')?.value)}">

                                <label iccLabel>
                                    <span *ngIf="isRequiredInOrder() && !contractorForm.get('invoiceFromDelivery').value" >*</span>
                                    {{ 'CONTACT|Kraj' | translate }}
                                </label>
                                <icc-select formControlName="countryId" autocomplete="billing country">
                                    <option
                                        *ngFor="let country of countries"
                                        [value]="country.id"
                                    >
                                        {{ country.name }}
                                    </option>
                                </icc-select>

                            </div>
                            <div
                                *ngIf="showRegions(contractorForm.get('invoice.countryId')?.value)"
                                class="w-50 pl-1"
                            >

                                <label iccLabel>
                                    <span *ngIf="isRequiredInOrder() && !contractorForm.get('invoiceFromDelivery').value" >*</span>
                                    {{ getRegionLabel(contractorForm.get('invoice.countryId')?.value) }}
                                </label>
                                <icc-select formControlName="regionId" autocomplete="billing address-level1">
                                    <option
                                        *ngFor="let region of getRegions(contractorForm.get('invoice.countryId')?.value)"
                                        [value]="region.id"
                                    >
                                        {{ region.name }}
                                    </option>
                                </icc-select>
                            </div>
                        </div>

                        <div class="flex-horizontal w-100">
                            <div class="fg-1" *ngIf="showSubregions(contractorForm.get('invoice.countryId')?.value)">
                                <label iccLabel>
                                    <span *ngIf="isRequiredInOrder() && !contractorForm.get('invoiceFromDelivery').value" >*</span>
                                    {{ getSubregionLabel(contractorForm.get('invoice.countryId')?.value) }}
                                </label>
                                <icc-select formControlName="subregionId" autocomplete="billing address-level2">
                                    <option
                                        *ngFor="let subregion of getSubregions(
                                            contractorForm.get('invoice.countryId')?.value,
                                            contractorForm.get('invoice.regionId')?.value
                                        )"
                                        [value]="subregion.id"
                                    >
                                        {{ subregion.name }}
                                    </option>
                                </icc-select>
                            </div>
                            <div class="fg-1">

                                <label iccLabel>
                                    <span *ngIf="isRequiredInOrder() && !contractorForm.get('invoiceFromDelivery').value" >*</span>
                                    {{ 'CONTACT|Kod pocztowy' | translate }}

                                </label>
                                <icc-input type="text" name="postal_code" formControlName="postalCode" ></icc-input>

                            </div>

                            <div class="fg-1">

                                <label iccLabel>
                                    <span *ngIf="isRequiredInOrder() && !contractorForm.get('invoiceFromDelivery').value" >*</span>
                                    {{ 'CONTACT|Miejscowość' | translate }}
                                </label>
                                <icc-input type="text" name="city" formControlName="city" autocomplete="billing address-level3" ></icc-input>

                            </div>
                        </div>

                        <div class="flex-vertical w-100">

                            <div class="w-100">
                                <label iccLabel>
                                    <span *ngIf="isRequiredInOrder() && !contractorForm.get('invoiceFromDelivery').value" >*</span>
                                    {{ 'CONTACT|Adres' | translate }}
                                </label>
                                <icc-input type="text" name="address_line_1" formControlName="addressLine1"  autocomplete="billing address-line1"></icc-input>
                            </div>

                            <div class="w-100">
                                <label iccLabel>
                                    {{ 'CONTACT|Adres cd.' | translate }}
                                </label>
                                <icc-input type="text" name="address_line_2" formControlName="addressLine2"  autocomplete="billing address-line2"></icc-input>
                            </div>

                        </div>


                    </section>

                </div>
                <div class="form-box">

                    <icc-checkbox name="otherContact" formControlName="otherContact">
                        {{ 'CONTACT|Wpisz inny adres do wysyłki dokumentów' | translate }}
                    </icc-checkbox>

                    <ng-container
                        *ngIf="contractorForm.get('otherContact')?.value"
                    >
                        <h4 class="w-100">{{ 'CONTACT|Adres do wysyłki dokumentów:' | translate }}</h4>

                        <section formGroupName="billingDelivery">

                            <div class="flex-horizontal w-100">
                                <div [ngClass]="{ 'w-100': !showRegions(contractorForm.get('billingDelivery.countryId')?.value),'w-50': showRegions(contractorForm.get('billingDelivery.countryId')?.value), 'pr-1': showRegions(contractorForm.get('invoice.countryId')?.value)}">

                                    <label iccLabel>
                                        <span *ngIf="isRequiredInOrder()" >*</span>
                                        {{ 'CONTACT|Kraj' | translate }}
                                    </label>
                                    <icc-select formControlName="countryId">
                                        <option
                                            *ngFor="let country of countries"
                                            [value]="country.id"
                                        >
                                            {{ country.name }}
                                        </option>
                                    </icc-select>

                                </div>
                                <div
                                    *ngIf="showRegions(contractorForm.get('billingDelivery.countryId')?.value)"
                                    class="w-50 pl-1"
                                >

                                    <label iccLabel>
                                        <span *ngIf="isRequiredInOrder()" >*</span>
                                        {{ getRegionLabel(contractorForm.get('billingDelivery.countryId')?.value) }}
                                    </label>
                                    <icc-select formControlName="regionId" >
                                        <option
                                            *ngFor="let region of getRegions(contractorForm.get('billingDelivery.countryId')?.value)"
                                            [value]="region.id"
                                        >
                                            {{ region.name }}
                                        </option>
                                    </icc-select>
                                </div>
                            </div>

                            <div class="flex-horizontal w-100">
                                <div class="fg-1" *ngIf="showSubregions(contractorForm.get('billingDelivery.countryId')?.value)">
                                    <label iccLabel>
                                        <span *ngIf="isRequiredInOrder()" >*</span>
                                        {{ getSubregionLabel(contractorForm.get('billingDelivery.countryId')?.value) }}
                                    </label>
                                    <icc-select formControlName="subregionId">
                                        <option
                                            *ngFor="let subregion of getSubregions(
                                                contractorForm.get('billingDelivery.countryId')?.value,
                                                contractorForm.get('billingDelivery.regionId')?.value
                                            )"
                                            [value]="subregion.id"
                                        >
                                            {{ subregion.name }}
                                        </option>
                                    </icc-select>
                                </div>
                                <div class="fg-1">

                                    <label iccLabel>
                                        <span *ngIf="isRequiredInOrder()" >*</span>
                                        {{ 'CONTACT|Kod pocztowy' | translate }}

                                    </label>
                                    <icc-input type="text" name="postal_code" formControlName="postalCode" ></icc-input>

                                </div>

                                <div class="fg-1">

                                    <label iccLabel>
                                        <span *ngIf="isRequiredInOrder()" >*</span>
                                        {{ 'CONTACT|Miejscowość' | translate }}
                                    </label>
                                    <icc-input type="text" name="city" formControlName="city"  ></icc-input>

                                </div>
                            </div>

                            <div class="flex-vertical w-100">

                                <div class="w-100">
                                    <label iccLabel>
                                        <span *ngIf="isRequiredInOrder()" >*</span>
                                        {{ 'CONTACT|Adres' | translate }}
                                    </label>
                                    <icc-input type="text" name="address_line_1" formControlName="addressLine1"  ></icc-input>
                                </div>

                                <div class="w-100">
                                    <label iccLabel>
                                        {{ 'CONTACT|Adres cd.' | translate }}
                                    </label>
                                    <icc-input type="text" name="address_line_2" formControlName="addressLine2"  ></icc-input>
                                </div>

                            </div>

                        </section>


                    </ng-container>
                </div>

            </form>

        </div>
        <div class="dialog-footer">

            <div class="flex-horizontal w-100">

                <button
                    iccButton
                    (click)="close()"
                    appearance="secondary"
                >
                    {{ 'INTERFACE|Anuluj' | translate}}
                </button>

                <div class="flex-horizontal right">

                    <button
                        iccButton
                        (click)="existing = true; showExistingContractorForm=false"
                        appearance="outline"
                    >
                        {{ 'INTERFACE|Wybierz z listy' | translate}}
                    </button>

                    <button
                        iccButton
                        (click)="add()"
                        appearance="primary"
                    >
                        {{ 'INTERFACE|Zapisz' | translate}}
                    </button>

                </div>

            </div>
        </div>

    </ng-container>

    <ng-container *ngIf="existing && showExistingContractorForm" >
        <div class="dialog-header">
            <h3>{{ 'SALES_DOCUMENT|Kupujący' | translate }}
                <ng-container
                    *ngIf="getShortName(selectedContractor)"
                >
                    : {{ getShortName(selectedContractor) }}
                </ng-container>
            </h3>

            <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
                <icc-icon name="close"></icc-icon>
            </button>

        </div>

        <div class="dialog-body">

            <div class="flex-vertical mb-2">

                <h1 class="w-100" >{{ 'SALES_DOCUMENT|Dane kontrahenta:' | translate }}</h1>

                <div class="w-100" >

                    <div
                        *ngIf="selectedContractor?.name"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'COMPANY|Firma:' | translate }}</span>
                        <span class="w-70 text-left pl-1"> {{ selectedContractor?.name }} </span>
                    </div>
                    <div
                        *ngIf="selectedContractor?.company?.vatNr"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'COMPANY|Nip:' | translate }}</span>
                        <span class="w-70 text-left pl-1">{{ selectedContractor.company.vatNr }}</span>
                    </div>
                    <div
                        *ngIf="selectedContractor?.company?.vatNrEu"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'COMPANY|VAT-EU:' | translate }}</span>
                        <span class="w-70 text-left pl-1">{{ selectedContractor.company.vatNrEu }}</span>
                    </div>
                    <div
                        *ngIf="selectedContractor?.email || selectedContractor?.registryEmail || selectedContractor?.invoiceEmail"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|E-mail kontaktowy:' | translate }}</span>
                        <span class="w-70 text-left pl-1">{{ selectedContractor?.version === 1 ? (selectedContractor.email || selectedContractor.registryEmail) : selectedContractor.invoiceEmail }}</span>
                    </div>
                    <div
                        *ngIf="selectedContractor?.phoneNumber || selectedContractor?.registryPhone || selectedContractor?.invoicePhone"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|Telefon kontaktowy:' | translate }}</span>
                        <span class="w-70 text-left pl-1">{{ selectedContractor?.version === 1 ? (selectedContractor.phoneNumber || selectedContractor.registryPhone) : selectedContractor.invoicePhone }}</span>
                    </div>
                </div>

            </div>

            <form [formGroup]="existingContractorForm">

                <div
                    *ngIf="existingContractorForm?.company?.resources?.length > 1"
                    class="w-100"
                >

                    <label iccLabel > {{ 'COMPANY|Oddział' | translate }} </label>
                    <icc-select
                        formControlName="departmentId"
                    >
                        <option
                            *ngFor="let department of selectedContractor?.company?.resources"
                            [value]="department.id"
                        >
                            {{ department.name }}
                        </option>
                    </icc-select>

                </div>

                <div
                    *ngIf="
                        selectedContractor?.isCompany
                        && (selectedContractor?.company?.workers[existingContractorForm.get('departmentId')?.value] || []).length > 0
                    "
                    class="w-100"
                >

                    <label iccLabel > {{ 'COMPANY|Osoba kontaktowa' | translate }} </label>
                    <icc-select
                        formControlName="workerId"
                        [attr.readonly]="(selectedContractor?.company?.workers[existingContractorForm.get('departmentId')?.value] || []).length < 2"
                    >
                        <option *ngFor="let worker of (selectedContractor?.company?.workers[existingContractorForm.get('departmentId')?.value] || [])"
                            [value]="worker.id"
                        >
                            {{ worker.referenceName }}
                        </option>
                    </icc-select>

                </div>

                <div class="w-100">

                    <h4>{{ 'CONTACT|Adres dostawy :' | translate }}</h4>
                    <icc-select
                        formControlName="deliveryId"
                    >
                        <option *ngFor="let address of getDeliveryAddresses(existingContractorForm.get('departmentId')?.value)" [value]="address.id">
                            {{ address.addressLine1 }}, {{ address.addressLine2 }}, {{ address.postalCode }}, {{ address.city }}, {{ address.countryId }}
                        </option>
                        <option [value]="0">{{ 'CONTACT|Inny adres' | translate }}</option>
                    </icc-select>

                </div>


                <section formGroupName="delivery">

                    <div class="flex-horizontal w-100">
                        <div [ngClass]="{ 'w-100': !showRegions(existingContractorForm.get('delivery.countryId')?.value),'w-50': showRegions(existingContractorForm.get('delivery.countryId')?.value), 'pr-1': showRegions(existingContractorForm.get('delivery.countryId')?.value)}">

                            <label iccLabel>
                                <span *ngIf="isRequiredInOrder()" >*</span>
                                {{ 'CONTACT|Kraj' | translate }}
                            </label>
                            <icc-select formControlName="countryId">
                                <option
                                    *ngFor="let country of countries"
                                    [value]="country.id"
                                >
                                    {{ country.name }}
                                </option>
                            </icc-select>

                        </div>
                        <div
                            *ngIf="showRegions(existingContractorForm.get('delivery.countryId')?.value)"
                            class="w-50 pl-1"
                        >

                            <label iccLabel>
                                <span *ngIf="isRequiredInOrder()" >*</span>
                                {{ getRegionLabel(existingContractorForm.get('delivery.countryId')?.value) }}
                            </label>
                            <icc-select formControlName="regionId" >
                                <option
                                    *ngFor="let region of getRegions(existingContractorForm.get('delivery.countryId')?.value)"
                                    [value]="region.id"
                                >
                                    {{ region.name }}
                                </option>
                            </icc-select>
                        </div>
                    </div>

                    <div class="flex-horizontal w-100">
                        <div class="fg-1" *ngIf="showSubregions(existingContractorForm.get('delivery.countryId')?.value)">
                            <label iccLabel>
                                <span *ngIf="isRequiredInOrder()" >*</span>
                                {{ getSubregionLabel(existingContractorForm.get('delivery.countryId')?.value) }}
                            </label>
                            <icc-select formControlName="subregionId">
                                <option
                                    *ngFor="let subregion of getSubregions(
                                        existingContractorForm.get('delivery.countryId')?.value,
                                        existingContractorForm.get('delivery.regionId')?.value
                                    )"
                                    [value]="subregion.id"
                                >
                                    {{ subregion?.name }}
                                </option>
                            </icc-select>
                        </div>
                        <div class="fg-1">

                            <label iccLabel>
                                <span *ngIf="isRequiredInOrder()" >*</span>
                                {{ 'CONTACT|Kod pocztowy' | translate }}

                            </label>
                            <icc-input type="text" name="postal_code" formControlName="postalCode" ></icc-input>

                        </div>

                        <div class="fg-1">

                            <label iccLabel>
                                <span *ngIf="isRequiredInOrder()" >*</span>
                                {{ 'CONTACT|Miejscowość' | translate }}
                            </label>
                            <icc-input type="text" name="city" formControlName="city"  ></icc-input>

                        </div>
                    </div>

                    <div class="flex-vertical w-100">

                        <div class="w-100">
                            <label iccLabel>
                                <span *ngIf="isRequiredInOrder()" >*</span>
                                {{ 'CONTACT|Adres' | translate }}
                            </label>
                            <icc-input type="text" name="address_line_1" formControlName="addressLine1"  ></icc-input>
                        </div>

                        <div class="w-100">
                            <label iccLabel>
                                {{ 'CONTACT|Adres cd.' | translate }}
                            </label>
                            <icc-input type="text" name="address_line_2" formControlName="addressLine2"  ></icc-input>
                        </div>

                    </div>

                </section>

            </form>

        </div>
        <div class="dialog-footer">

            <div class="flex-horizontal w-100">

                <button
                    iccButton
                    (click)="close()"
                    appearance="secondary"
                >
                    {{ 'INTERFACE|Anuluj' | translate}}
                </button>

                <div class="flex-horizontal right">

                    <button
                        iccButton
                        (click)="existing = true; showExistingContractorForm=false"
                        appearance="outline"
                    >
                        {{ 'INTERFACE|Wybierz z listy' | translate}}
                    </button>

                    <button
                        iccButton
                        (click)="saveExisting()"
                        appearance="primary"
                    >
                        {{ 'INTERFACE|Zapisz' | translate}}
                    </button>

                </div>

            </div>
        </div>

    </ng-container>

    <ng-container *ngIf="existing && !showExistingContractorForm" >
        <div class="dialog-header">
            <h3>{{ 'SALES_DOCUMENT|Lista kontrahentów' | translate }}</h3>

            <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
                <icc-icon name="close"></icc-icon>
            </button>

        </div>
        <div class="dialog-tools contractor-search-form">
            <div class="flex-horizontal" *ngIf="mobileView">
                <div class="w-100">
                    <label iccLabel>{{ 'INTERFACE|Wyszukaj (min. 3 znaki)' | translate }}</label>
                    <icc-input
                        #searchInput
                        type="text"
                        [value]="searchCombined"
                        minLength="3"
                        maxLength="100"
                        [supportText]="'SALES_DOCUMENT|Nazwa kontrahenta, e-mail, nr tel., osoba kontaktowa, NIP, adres (min. 3 znaki)' | translate"
                        (valueChange)="searchCombined = $event"
                        (keyup.enter)="handleSearch()"
                    ></icc-input>
                </div>
            </div>
            <div class="flex-horizontal" *ngIf="!mobileView">
                <div class="w-100">
                    <label iccLabel>{{ 'INTERFACE|Wyszukaj (min. 3 znaki)' | translate }}</label>
                    <icc-input
                        #searchInput
                        type="text"
                        [value]="searchWord"
                        minLength="3"
                        maxLength="100"
                        [supportText]="'SALES_DOCUMENT|Nazwa kontrahenta, e-mail, nr tel., osoba kontaktowa (min. 3 znaki)' | translate"
                        (valueChange)="searchWord = $event"
                        (keyup.enter)="handleSearch()"
                    ></icc-input>
                </div>
            </div>
            <div class="flex-horizontal">
                <div div class="fg-4 pr-1" *ngIf="!mobileView">
                    <label iccLabel>{{ 'COMPANY|NIP/VAT UE' | translate }}</label>
                    <icc-input
                        #searchNipInput
                        type="text"
                        [value]="searchNip"
                        minLength="3"
                        maxLength="100"
                        (valueChange)="searchNip = $event"
                        [supportText]="'COMPANY|Numer podatkowy (min. 3 znaki)' | translate"
                        (keyup.enter)="handleSearch()"
                    ></icc-input>
                </div>
                <div class="fg-4 pr-1 " *ngIf="!mobileView">
                    <label iccLabel>{{ 'CONTACT|Adres' | translate }}</label>
                    <icc-input
                        #searchNipInput
                        type="text"
                        [value]="searchAddress"
                        minLength="3"
                        maxLength="100"
                        (valueChange)="searchAddress = $event"
                        [supportText]="'CONTACT|Miejscowość, kod pocztowy lub adres (min. 3 znaki)' | translate"
                        (keyup.enter)="handleSearch()"
                    ></icc-input>
                </div>
                <div class="fg-1 pt-1">
                    <button
                        iccButton
                        class="right"
                        (click)="handleSearch()"
                    >
                        <icc-icon name="search"></icc-icon>
                        {{ 'INTERFACE|Wyszukaj' | translate }}
                    </button>
                </div>
            </div>
        </div>
        <div class="dialog-body dialog-contractors-list">
            <table *ngIf="!mobileView">
                <thead>
                    <tr>
                        <th>{{ 'COMPANY|REF. / N. skróc.' | translate }}</th>
                        <th>{{ 'COMPANY|Nazwa' | translate }}</th>
                        <th>{{ 'COMPANY|NIP / VAT-UE' | translate }}</th>
                        <th>{{ 'COMPANY|Lokalizacja' | translate }}</th>
                        <th>{{ 'CONTACT|E-mail / Nr tel.' | translate }}</th>
                        <th></th>
                    </tr>

                </thead>
                <tbody>
                    <tr *ngFor="let contractor of contractors | paginate: { itemsPerPage: recordsOnPage, currentPage: page } " >
                        <td >{{ getShortName(contractor) }} </td>
                        <td >{{contractor?.name}}</td>
                        <td >
                            {{contractor?.company?.vatNr}}
                            <ng-container *ngIf="contractor?.company?.vatNrEu">
                                / {{contractor.company.vatNrEu}}
                            </ng-container>
                        </td>
                        <td >
                            {{ getContractorLocalization(contractor) }}
                        </td>
                        <td >
                            {{ getContractorEmailPhone(contractor) }}
                        </td>
                        <td class="dialog-actions" >
                            <button
                                iccIconButton
                                (click)="select(contractor.id)"
                                appearance="flat"
                            >
                                <icc-icon name="done"></icc-icon>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div *ngIf="mobileView" class="client-card-list">
                <div *ngFor="let contractor of contractors | paginate: { itemsPerPage: recordsOnPage, currentPage: page } " class="client-card" (click)="select(contractor.id)">
                    <p class="client-card__header">{{ contractor?.name }}</p>
                    <p>
                        <span class="text-uppercase">{{ 'COMPANY|NIP' | translate }}:</span>
                        <span>
                            {{ contractor?.company?.vatNr }}
                            <ng-container *ngIf="contractor?.company?.vatNrEu && contractor?.company?.vatNrEu !== contractor?.company?.vatNr">
                                / {{ contractor.company.vatNrEu }}
                            </ng-container>
                        </span>
                    </p>
                    <p>{{ getContractorLocalization(contractor) }}</p>
                    <p>{{ getContractorEmailPhone(contractor) }}</p>
                </div>
            </div>
        </div>
        <div class="dialog-footer">

            <div class="dialog-actions">

                <pagination-controls

                    (pageChange)="onChangePage($event)"
                    [previousLabel]="'INTERFACE|Poprzednia' | translate"
                    [nextLabel]="'INTERFACE|Następna' | translate"
                    maxSize="6"

                ></pagination-controls>
                <button
                    *ngIf="!data.isServiceOrder"
                    iccButton
                    (click)="existing = false"
                    appearance="outline"
                >
                    {{ 'INTERFACE|Wprowadź ręcznie' | translate}}
                    <icc-icon name="close"></icc-icon>
                </button>

            </div>
        </div>

    </ng-container>

</div>
<div
    class="curtain"
    (click)="close()"
></div>